import classNames from "classnames";
import { useParams } from "react-router";
import { MetadataType, MDOption, CardVariant } from "types";
import HeaderTitle from "./HeaderTitle";
import CardMetadataLabels from "views/components/CardMetadataLabels";
import styles from "./style.module.scss";
import { ReactNode } from "react";

export interface CardHeaderProps {
  index: number;
  debugInfo?: string;
  cardVariant: CardVariant;
  selectedLabels: any;
  mdOptions: MDOption[];
  prefix: React.ReactNode;
  suffix?: { tooltipText: string; icon: ReactNode };
  // Extra content shown at the end of the title row
  titleAddon?: ReactNode;
  cardMdType: MetadataType;
  mdLabels: string[] | null;
  title: string | JSX.Element;
  selectedMdIcon: JSX.Element;
  onViewClick: (type: MetadataType) => void;
  onMDLabelSelection?: (label: string) => void;
  onViewAllClick: (type: MetadataType) => void;
}

const CardHeader = ({
  index,
  title,
  cardVariant,
  mdLabels,
  mdOptions,
  prefix,
  suffix,
  titleAddon,
  debugInfo,
  cardMdType,
  selectedLabels,
  selectedMdIcon,
  onViewClick,
  onViewAllClick,
  onMDLabelSelection,
}: CardHeaderProps) => {
  const { enrichDatasetId, newDatasetId } = useParams();
  const showOptionsIcon = !(enrichDatasetId || newDatasetId);

  const cardHeadClassnames = classNames(styles.cardHead, {
    [styles.unClickable]: cardVariant === CardVariant.VERTEX,
    [styles.defaultCursor]: !showOptionsIcon,
  });

  return (
    <div className={cardHeadClassnames}>
      {title && (
        <div className={styles.titleRow}>
          <HeaderTitle
            title={title}
            index={index}
            prefix={prefix}
            debugInfo={debugInfo}
            cardVariant={cardVariant}
            suffix={title ? suffix : undefined}
          />
          {titleAddon}
        </div>
      )}
      {mdLabels ? (
        <CardMetadataLabels
          labels={mdLabels}
          options={mdOptions}
          metadataType={cardMdType}
          cardVariant={cardVariant}
          labelIcon={selectedMdIcon}
          selectedLabels={selectedLabels}
          showOptionsIcon={showOptionsIcon}
          onViewClick={onViewClick}
          onViewAllClick={onViewAllClick}
          onLabelSelection={onMDLabelSelection}
          suffix={!title ? suffix : undefined}
        />
      ) : (
        <div className={styles.lowerRow}>
          <div
            className={styles.previewLoader}
            data-testid="preview-loader"
          ></div>
        </div>
      )}
    </div>
  );
};

export default CardHeader;
